/**
 * 同步路由和store
 * 使可直接在store中使用路由数据
 */

export function afterStoreCreate(store, { registerStore }) {
  registerStore({
    namespace: 'route',
    state: {},
    mutations: {
      $$change(state, payload) {
        Object.assign(state, payload.to)
        state.from = payload.from
      }
    }
  })
}

export function beforeAppCreate({ router, store }) {
  router.afterEach((to, from) => {
    store.commit('route/$$change', { to: cloneRoute(to), from: cloneRoute(from) })
  })
}

function cloneRoute(route) {
  return Object.freeze({
    name: route.name,
    path: route.path,
    hash: route.hash,
    query: route.query,
    params: route.params,
    fullPath: route.fullPath,
    meta: route.meta,
    matched: route.matched.map(item => item.regex)
  })
}
